import { JSX, createEffect, createSignal, splitProps } from 'solid-js';
import { DOMElement } from 'solid-js/jsx-runtime';
import cx from 'classnames';
import { noop } from 'lodash-es';
import Loading from './Loading';
import { Toggle } from './Toggle';
import WebApp from '@twa-dev/sdk';

interface ClickHandler<T> {
  (e: MouseEvent & { currentTarget: HTMLButtonElement; target: DOMElement }): T;
}
export interface ButtonProps<T = any> extends Omit<JSX.ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'onClick'> {
  type?: ButtonType;
  onClick?: ClickHandler<T>;
  loading?: boolean;
}

const types = {
  brand: 'button-brand h-[4.5rem]',
  second: 'button-second',
  info: 'button-info',
  disabled: 'button-disabled',
  mini: 'button-mini',
};
type ButtonType = keyof typeof types;

/**
 * 按钮，添加了几个常用的样式，
 * 然后添加了loading逻辑
 * 1、onClick事件返回Promise就会自动触发loading
 * // onClick事件触发transition也会触发loading(solid的transition貌似理解有误，不能这样使用2)
 * @param props
 * @returns
 */
export default function Button(props: ButtonProps) {
  const [typeAndClick, others] = splitProps(props, ['type', 'onClick']);
  const [load, setLoad] = createSignal(false);
  const propsOnclick = props.onClick;
  const onClick: typeof propsOnclick =
    propsOnclick &&
    function click(e: any) {
      WebApp.HapticFeedback.notificationOccurred("success");
      const res = propsOnclick(e);
      // 改成thenable？@Zip
      if (res instanceof Promise) {
        setLoad(true);
        res.then(() => setLoad(false));
      }
    };

  return (
    <button
      {...others}
      class={cx('button text-xl', types[typeAndClick.type!], props.class)}
      onClick={props.disabled || props.loading || load() ? noop : onClick}
    >
      <Toggle when={!load() && !props.loading} fallback={<Loading />}>
        {props.children}
      </Toggle>
    </button>
  );
}
